import { render, staticRenderFns } from "./OrderDialogTableMoney.vue?vue&type=template&id=a0de32ba"
import script from "./OrderDialogTableMoney.vue?vue&type=script&lang=ts"
export * from "./OrderDialogTableMoney.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports